import { ReactComponent as PackageIcon } from 'assets/icons/package.svg';
import { Card, FormGrid } from 'components/molecules';
import ViewHint from 'components/molecules/hint/ViewHint';
import { useFormikContext } from 'formik';
import { IFormikContextType } from 'hooks/useFormikField';
import { useCustomParamId } from 'hooks/useParamId';
import middleware from 'middleware';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import {
  useGetMusicProductDigitalDeliveries,
  useGetMusicProductDigitalDeliveryInformation,
} from 'services/music-product-digital/delivery';
import { DELIVERY_STATUS } from 'services/music-product-digital/types/enums';
import { IMusicProductDigitalForm } from 'services/music-product-digital/types/form';

const MusicProductDigitalDelivery = () => {
  const id = useCustomParamId('id', '/music-product-digital');

  const digitalDeliveryInformation = useGetMusicProductDigitalDeliveryInformation(id);

  const navigate = useNavigate();

  const { t } = useTranslation();

  const { values, setFieldValue }: IFormikContextType<IMusicProductDigitalForm> =
    useFormikContext<IMusicProductDigitalForm>();

  const deliveries = useGetMusicProductDigitalDeliveries(
    id,
    values.deliveryFilter?.onlyDefaultProviders,
  );

  return (
    <div className="flex flex-col w-full gap-4 pb-24">
      <ViewHint hintId="music-product-digital-delivery" />

      {values.deliveryFilter?.onlyDefaultProviders && (
        <Card.Delivery
          highlighted
          service={{
            ...(deliveries.data ?? [])[0],
            deliveryStatus:
              digitalDeliveryInformation.data?.insert || digitalDeliveryInformation.data?.delivery
                ? (digitalDeliveryInformation.data?.delivery?.status ?? DELIVERY_STATUS.notSend)
                : DELIVERY_STATUS.unavailable,
            salesChannelName: t('music-product-digital.delivery.send-everywhere'),
          }}
          onClick={() => navigate('all')}
          customIcon={
            <PackageIcon height={50} width={50} style={{ fill: 'var(--text)', opacity: 0.5 }} />
          }
        />
      )}
      <div />
      <ViewHint hintId="music-product-digital-delivery-singly" />
      <FormGrid minWidth={300}>
        {deliveries.data?.map((service, key) => (
          <Card.Delivery
            key={key}
            service={service}
            onClick={() => {
              setFieldValue('delivery', middleware.digitalDelivery.serviceQueryToForm(service));
              navigate(`${service.salesChannelId}/${service.providerId}`, {
                preventScrollReset: true,
              });
            }}
          />
        ))}
      </FormGrid>
    </div>
  );
};

export default MusicProductDigitalDelivery;
